/**
 * E-posta adresini KISMEN maskeler (CLOS-74 `[035]` kararı 2).
 *
 * ### Neden var
 *
 * Davet görüntüleme ucu (`GET /api/invitations`) oturum gerektirmiyor — davetli
 * kaydolmadan önce hangi organizasyona çağrıldığını görebilsin diye. Ama linki eline
 * geçiren biri hedefin TAM adresini öğrenmemeli. Ürün kararı: yerel bölümün ilk harfi
 * görünür, gerisi `***`, alan adı açık. Böylece davetli hangi hesapla giriş yapacağını
 * anlar ama adres ifşa olmaz.
 *
 * ### Bir kapı DEĞİL, bir gizleme
 *
 * Bu yalnızca GÖSTERİMİ kısıtlar; erişim kararı sunucudaki eşleşme kontrolündedir
 * (`acceptInvitation`, tam adresle karşılaştırır). Maskeleme yanlışsa bile hiçbir kapı
 * açılmaz — yalnız ekranda daha fazla/az harf görünür.
 */
export function maskEmail(email: string): string {
  const at = email.indexOf("@");
  // @ yoksa geçerli bir adres değil; hiçbir şeyi açık bırakma.
  if (at < 0) return "***";

  const yerel = email.slice(0, at);
  const alan = email.slice(at); // "@" dahil

  // İlk harf yerel bölümden gelir (Türkçe karakter dahil, tek code point). Yerel bölüm
  // boşsa sızdıracak harf de yoktur.
  const ilk = [...yerel][0] ?? "";
  return `${ilk}***${alan}`;
}
